/* eslint-disable sort-keys */

const menuData = () => ({
  categories: [
    {
      name: "Shop By",
      device: "all",
      images: [],
      sections: [
        {
          title: "Featured",
          links: [
            ...(sl.config.sale_key.includes("jewlr_days_sale")
              ? [
                  {
                    name: "JEWLR DAYS SALE",
                    style: { color: "sale" },
                    url: "/jewlr-days-sale",
                  },
                ]
              : []),
            {
              name: "Bestsellers",
              url: "/best-sellers",
            },
            {
              name: "New",
              url: "/new-items",
            },
            ...(sl.config.sale_key.includes("jewlr_days_sale")
              ? []
              : [
                  {
                    name: "Summer Sale",
                    url: "/summer-sale-collection",
                  },
                  {
                    name: "4th of July Sale",
                    url: "/4th-of-july-jewelry-sale",
                  },
                ]),
            {
              name: "Mega Deals",
              url: "/mega-deals-collection",
            },
            {
              name: "Lee Fiori Collection",
              url: "/lee-fiori-collection",
            },
            {
              name: "Vacation Edit",
              url: "/vacation-edit",
            },
            {
              name: "Everyday Essentials",
              url: "/everyday-jewelry",
            },
            {
              name: "Watches",
              url: "/all-womens-watches",
            },
          ],
        },
        {
          title: "Collection",
          links: [
            {
              name: "Birthstone",
              url: "/birthstone-jewelry",
            },
            {
              name: "Name",
              url: "/name-jewelry",
            },
            {
              name: "Religious",
              url: "/religious-jewelry",
            },
            {
              name: "Promise",
              url: "/promise-rings",
            },
            {
              name: "Infinity",
              url: "/infinity-jewelry",
            },
            {
              name: "Diamond",
              url: "/diamond-jewelry",
            },
            {
              name: "Pearl",
              url: "/pearl-jewelry",
            },
            {
              name: "Zodiac & Birthstone",
              url: "/zodiac-and-birthstone-jewelry",
            },
            {
              name: "Heart",
              url: "/heart-jewelry",
            },
            {
              name: "Jewelry Sets",
              url: "/gift-sets",
            },
          ],
        },
        {
          title: "Gifts",
          links: [
            {
              name: "Gifts for Mom",
              url: "/for-mom",
            },
            {
              name: "Gifts for Dad",
              url: "/for-dad",
            },
            {
              name: "Gifts for Girlfriend",
              url: "/for-girlfriend",
            },
            {
              name: "Girls for Boyfriend",
              url: "/for-boyfriend",
            },
            {
              name: "Gifts for Kids",
              url: "/kids-jewelry",
            },
          ],
        },
        {
          title: "Occasion",
          links: [
            {
              name: "Graduation",
              url: "/graduation-gifts",
            },
            {
              name: "New Mom",
              url: "/push-presents",
            },
            {
              name: "Anniversary",
              url: "/anniversary-gifts",
            },
            {
              name: "Birthday",
              url: "/birthday-gifts",
            },
            {
              name: "First Communion",
              url: "/communion-gfits",
            },
            {
              name: "Bar/Bat Mitzvah",
              url: "/judaica",
            },
          ],
        },
        {
          title: "Partnerships",
          links: [
            {
              name: "Indochino",
              url: "/indochino-landing",
            },
            {
              name: "Cooper Alan",
              url: "/cooper-alan",
            },
            {
              name: "Student Athlete",
              url: "/postgame",
            },
            {
              name: "Family and Lifestyle",
              url: "/family-lifestyle",
            },
            {
              name: "All Partnership Collections",
              url: "/brand-partnerships",
            },
          ],
        },
      ],
    },
    {
      name: "Rings",
      device: "all",
      images: [],
      sections: [
        {
          title: "Featured",
          links: [
            {
              name: "Sale",
              url: "/womens-rings?filtered_tags%5B%5D=on-sale",
            },
            {
              name: "Bestsellers",
              url:
                "/womens-rings?filtered_tags%5B%5D=best-seller&switchMode=true",
            },
            {
              name: "New",
              url:
                "/new-items?filtered_tags%5B%5D=for-her&filtered_tags%5B%5D=rings",
            },
            {
              name: "All Rings",
              url: "/womens-rings",
            },
          ],
        },
        {
          title: "Style",
          links: [
            {
              name: "Promise",
              url: "/promise-rings-for-her",
            },
            {
              name: "Mother’s",
              url: "/mothers-rings",
            },
            {
              name: "Birthstone",
              url: "/birthstone-rings",
            },
            {
              name: "Everyday",
              url: "/everyday-rings",
            },
            {
              name: "Engagement",
              url: "/all-engagement-rings",
            },
            {
              name: "Wedding",
              url: "/bands-for-her",
            },
          ],
        },
        {
          title: "Material",
          links: [
            {
              name: "Sterling Silver",
              url: "/womens-rings?filtered_tags%5B%5D=sterling-silver",
            },
            {
              name: "Yellow Gold",
              url: "/womens-rings?filtered_tags%5B%5D=yellow-gold",
            },
            {
              name: "White Gold",
              url: "/womens-rings?filtered_tags%5B%5D=white-gold",
            },
            {
              name: "Rose Gold",
              url: "/womens-rings?filtered_tags%5B%5D=rose-gold",
            },
            {
              name: "Pearls",
              url: "/pearl-jewelry?filtered_tags%5B%5D=rings",
            },
          ],
        },
      ],
    },
    {
      name: "Necklaces",
      device: "all",
      images: [],
      sections: [
        {
          title: "Featured",
          links: [
            {
              name: "Sale",
              url: "/womens-necklaces?filtered_tags%5B%5D=on-sale",
            },
            {
              name: "Bestsellers",
              url: "/womens-necklaces?filtered_tags%5B%5D=best-seller",
            },
            {
              name: "New",
              url:
                "/new-items?filtered_tags%5B%5D=for-her&filtered_tags%5B%5D=pendants",
            },
            {
              name: "All Necklaces",
              url: "/womens-necklaces",
            },
          ],
        },
        {
          title: "Style",
          links: [
            {
              name: "Name",
              url: "/name-necklaces",
            },
            {
              name: "Initial",
              url: "/initial-necklaces",
            },
            {
              name: "Birthstone",
              url: "/birthstone-necklaces",
            },
            {
              name: "Mother’s",
              url: "/necklaces-for-mom",
            },
            {
              name: "Heart",
              url: "/womens-heart-necklaces",
            },
            {
              name: "Layering",
              url: "/womens-bundle-necklaces",
            },
            {
              name: "Kid’s",
              url: "/kids-necklaces",
            },
          ],
        },
        {
          title: "Material",
          links: [
            {
              name: "Sterling Silver",
              url: "/womens-necklaces?filtered_tags%5B%5D=sterling-silver",
            },
            {
              name: "Yellow Gold",
              url: "/womens-necklaces?filtered_tags%5B%5D=yellow-gold",
            },
            {
              name: "White Gold",
              url: "/womens-necklaces?filtered_tags%5B%5D=white-gold",
            },
            {
              name: "Rose Gold",
              url: "/womens-necklaces?filtered_tags%5B%5D=rose-gold",
            },
            {
              name: "Gold plated",
              url: "/womens-necklaces?filtered_tags%5B%5D=gold-plated",
            },
            {
              name: "Vermeil",
              url: "/womens-necklaces?filtered_tags%5B%5D=vermeil",
            },
            {
              name: "Pearls",
              url: "/pearl-jewelry?filtered_tags%5B%5D=pendants",
            },
          ],
        },
      ],
    },
    {
      name: "Earrings",
      device: "all",
      images: [],
      sections: [
        {
          title: "Featured",
          links: [
            {
              name: "Sale",
              url: "/earrings?filtered_tags%5B%5D=on-sale",
            },
            {
              name: "Bestsellers",
              url: "/earrings?filtered_tags%5B%5D=best-seller",
            },
            {
              name: "New",
              url: "/earrings?filtered_tags%5B%5D=best-seller",
            },
            {
              name: "All Earrings",
              url: "/earrings",
            },
          ],
        },
        {
          title: "Style",
          links: [
            {
              name: "Birthstone",
              url: "/birthstone-studs",
            },
            {
              name: "Diamond",
              url: "/diamond-stud-earrings",
            },
            {
              name: "Hoops & Huggies",
              url: "/hoop-earrings",
            },
            {
              name: "Dainty",
              url: "/everyday-earrings",
            },
            {
              name: "Name",
              url: "/name-earrings",
            },
            {
              name: "Kid’s",
              url: "/kids-earrings",
            },
          ],
        },
        {
          title: "Material",
          links: [
            {
              name: "Sterling Silver",
              url: "/earrings?filtered_tags%5B%5D=sterling-silver",
            },
            {
              name: "Yellow Gold",
              url: "/earrings?filtered_tags%5B%5D=yellow-gold",
            },
            {
              name: "White Gold",
              url: "/earrings?filtered_tags%5B%5D=white-gold",
            },
            {
              name: "Rose Gold",
              url: "/earrings?filtered_tags%5B%5D=rose-gold",
            },
            {
              name: "Pearls",
              url: "/pearl-jewelry?filtered_tags%5B%5D=earrings",
            },
          ],
        },
      ],
    },
    {
      name: "Bracelets",
      device: "all",
      images: [],
      sections: [
        {
          title: "Featured",
          links: [
            {
              name: "Sale",
              url: "/womens-bracelets?filtered_tags%5B%5D=on-sale",
            },
            {
              name: "Bestsellers",
              url: "/womens-bracelets?filtered_tags%5B%5D=best-seller",
            },
            {
              name: "New",
              url:
                "/new-items?filtered_tags%5B%5D=bracelets&filtered_tags%5B%5D=for-her",
            },
            {
              name: "All Bracelets",
              url: "/womens-bracelets",
            },
          ],
        },
        {
          title: "Style",
          links: [
            {
              name: "Name",
              url: "/name-bracelets",
            },
            {
              name: "Birthstone",
              url: "/birthstone-bracelets",
            },
            {
              name: "Mother’s",
              url: "/mothers-bracelets",
            },
            {
              name: "Everyday",
              url: "/everyday-bracelets",
            },
            {
              name: "Anklets",
              url: "/everyday-anklets",
            },
            {
              name: "Kid’s",
              url: "/kids-bracelets",
            },
          ],
        },
        {
          title: "Material",
          links: [
            {
              name: "Sterling Silver",
              url: "/womens-bracelets?filtered_tags%5B%5D=sterling-silver",
            },
            {
              name: "Yellow Gold",
              url: "/womens-bracelets?filtered_tags%5B%5D=yellow-gold",
            },
            {
              name: "White Gold",
              url: "/womens-bracelets?filtered_tags%5B%5D=white-gold",
            },
            {
              name: "Rose Gold",
              url: "/womens-bracelets?filtered_tags%5B%5D=rose-gold",
            },
            {
              name: "Gold Plated",
              url: "/womens-bracelets?filtered_tags%5B%5D=gold-plated",
            },
            {
              name: "Vermeil",
              url: "/womens-bracelets?filtered_tags%5B%5D=vermeil",
            },
            {
              name: "Pearls",
              url: "/pearl-jewelry?filtered_tags%5B%5D=bracelets",
            },
          ],
        },
      ],
    },
    {
      name: "Mens",
      device: "all",
      images: [],
      sections: [
        {
          title: "Featured",
          links: [
            {
              name: "Sale",
              url: "/sale-for-him",
            },
            {
              name: "Bestsellers",
              url: "/best-sellers-for-him",
            },
            {
              name: "New",
              url: "/new-items?filtered_tags[]=for-him&switchMode=true",
            },
            {
              name: "All Mens",
              url: "/mens-jewelry",
            },
          ],
        },
        {
          title: "Categories",
          links: [
            {
              name: "Rings",
              url: "/mens-rings",
            },
            {
              name: "Necklaces",
              url: "/mens-necklaces",
            },
            {
              name: "Bracelets",
              url: "/mens-bracelets",
            },
            {
              name: "Watches",
              url: "/all-mens-watches",
            },
            {
              name: "Earrings",
              url: "/mens-earrings",
            },
            {
              name: "Accessories",
              url: "/mens-accessories",
            },
          ],
        },
        {
          title: "Style",
          links: [
            {
              name: "Promise Rings",
              url: "/mens-promise-rings",
            },
            {
              name: "Classic Bands",
              url: "/classic-mens",
            },
            {
              name: "Chains & Pendants",
              url: "/mens-chains",
            },
            {
              name: "Engravable Necklaces",
              url: "/mens-engravable-necklaces",
            },
            {
              name: "Leather Bracelets",
              url: "/mens-leather-bracelets",
            },
            {
              name: "ID Bracelets",
              url: "/mens-id-bracelets",
            },
          ],
        },
        {
          title: "Shop By Material",
          links: [
            {
              name: "Sterling Silver",
              url: "/mens-jewelry?filtered_tags%5B%5D=sterling-silver",
            },
            {
              name: "Gold",
              url: "/mens-jewelry?filtered_tags%5B%5D=yellow-gold",
            },
            {
              name: "Tungsten",
              url: "/mens-jewelry?filtered_tags%5B%5D=tungsten",
            },
            {
              name: "Stainless Steel",
              url: "/mens-necklaces?filtered_tags%5B%5D=stainless-steel",
            },
            {
              name: "Leather",
              url: "/mens-leather-bracelets",
            },
          ],
        },
      ],
    },
    {
      name: "Wedding",
      device: "all",
      images: [],
      sections: [
        {
          title: "Engagement",
          links: [
            {
              name: "Bestsellers",
              url: "/best-selling-engagement-rings",
            },
            {
              name: "New",
              url: "/new-engagement-rings",
            },
            {
              name: "Bridal Sets",
              url: "/bridal-sets",
            },
            {
              name: "Diamond Rings for Every Budget",
              url: "/diamond-promise-ring-landing",
            },
            {
              name: "All Engagement",
              url: "/engagement-rings-landing",
            },
          ],
        },
        {
          title: "Wedding",
          links: [
            {
              name: "Bands for Her",
              url: "/bands-for-her",
            },
            {
              name: "Bands for Him",
              url: "/bands-for-him",
            },
            {
              name: "Couple’s Bands",
              url: "/matching-wedding-bands",
            },
            {
              name: "Wedding Party",
              url: "/all-wedding-party",
            },
            {
              name: "All Wedding",
              url: "/bridal-event-collection",
            },
          ],
        },
        {
          title: "Shop By Stone",
          links: [
            {
              name: "Diamond",
              url:
                "/all-engagement-rings?filtered_tags%5B%5D=genuine-diamond&switchMode=true",
            },
            {
              name: "Lab Diamond",
              url:
                "/all-engagement-rings?filtered_tags%5B%5D=lab-diamond&switchMode=true",
            },
            {
              name: "Moissanite",
              url:
                "/all-engagement-rings?filtered_tags%5B%5D=moissanite&switchMode=true",
            },
            {
              name: "Cubic Zirconia",
              url:
                "/all-engagement-rings?filtered_tags%5B%5D=cubic-zirconia&switchMode=true",
            },
            {
              name: "Gemstone",
              url:
                "/all-engagement-rings?filtered_tags%5B%5D=blue-sapphire&switchMode=true",
            },
          ],
        },
      ],
    },
  ],
})

export default menuData
